import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  nameTile: {
    minHeight: '6rem',
    background:
      'linear-gradient(90deg, rgba(9,121,12,1) 0%, rgba(0,91,255,1) 100%)',
    border: '1px solid #ccc',
    fontSize: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateTile: {
    backgroundColor: 'white',
    border: '1px solid #ccc',
    padding: 10,
    textAlign: 'left',
    fontSize: 16,
    minHeight: '6rem',
    display: 'inline-grid',
    alignItems: 'center',
    width: '100%',
  },
  leaveTile: {
    backgroundColor: 'white',
    border: '1px solid #ccc',
    padding: 10,
    textAlign: 'left',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '6rem',
    maxHeight: '8rem',
    overflowY: 'auto',
    overflowX: 'auto',
  },
  quotaTile: {
    backgroundColor: 'white',
    textAlign: 'left',
    fontSize: 16,
    minHeight: '6rem',
    display: 'inline-grid',
  },
  workPayrollTile: {
    backgroundColor: 'white',
    border: '1px solid #ccc',
    padding: 10,
    textAlign: 'left',
    fontSize: 16,
    minHeight: '6rem',
  },
}));
